import { addNewStateButton } from './addNewStateButton';
import { stateWidget } from './stateWidget';
import { getUniqueStateName } from './fsm_utils';
import { simpleClone } from '../../../helpers';
import widgets from '../../widgets';

export const innerInstructionCard = (props) => {
  const getStates = () => simpleClone(props.instruction.getParameter('states'));
  const updateStates = (pNewStates) => props.instruction.updateParams('states', pNewStates);

  const lStates = getStates().map((state, stateIndex, states) => stateWidget({
    ...props,
    state,
    states,
    onStateChange: (pNewState) => {
      const lNewStates = getStates();
      const lOldStateName = lNewStates[stateIndex].stateName;

      lNewStates[stateIndex] = pNewState;

      if(lOldStateName !== lNewStates[stateIndex].stateName) {
        lNewStates
          .map(pState => pState.targetStates)
          .flat()
          .filter(pTargetState => pTargetState.stateName === lOldStateName)
          .forEach(pTargetState => pTargetState.stateName = pNewState.stateName);
      }
      updateStates(lNewStates);
    },
    onDeleteState: () => {
      const lStates = getStates();
      const lNumberOfAffectedTargetStates = lStates
        .map(pState => pState.targetStates)
        .flat()
        .filter(pTargetState => pTargetState.stateName === state.stateName)
        .length;
      if(lNumberOfAffectedTargetStates > 0) {
        widgets.showConfirmationModal(
          'Delete State',
          `This action will result in ${lNumberOfAffectedTargetStates} invalid next state${lNumberOfAffectedTargetStates > 1 ? 's' : ''}.`,
          () => {
            //handle on confirm
            lStates.splice(stateIndex, 1);
            updateStates(lStates);
          }
        );
      } else {
        lStates.splice(stateIndex, 1);
        updateStates(lStates);
      }


    },
    onStateMove: (direction) => {
      const lNewStates = getStates();
      const lOldIndex = stateIndex;
      const lNewIndex = direction === 'up' ? stateIndex - 1 : stateIndex + 1;
      const lStates = lNewStates.splice(lOldIndex, 1);
      lNewStates.splice(lNewIndex, 0, ...lStates);
      updateStates(lNewStates);
    },
    isLastState: stateIndex === getStates().length - 1,
    isFirstState: stateIndex === 0
  }));

  const onAddNewState = () => {
    const lNewStates = getStates();
    const lStateNames = lNewStates.map(pState => pState.stateName);
    lNewStates.push({
      actionSequenceName: "",
      stateName: getUniqueStateName(lStateNames, 'idle'),
      targetStates: []
    });
    updateStates(lNewStates);
  };
  const lFooter = $('<div>').append(
    addNewStateButton({onAddNewState: onAddNewState})
  );
  return $('<div>').append(
    $('<div>').append(
      ...lStates,
    ),
    lFooter
  );
};
